import React, { useState, useEffect } from "react"
import firebase from "gatsby-plugin-firebase"
import SideColumnWrapper from "../side-column-wrapper/side-column-wrapper"
import {
  NewsLetter,
  NewsLetterInner,
  sideColumnTitle,
  sideColumnText,
} from "./cta-newsletter.module.css"
import { getUser } from "../../../services/users"
import HubSpotForm from "../../hubspot-form/hubspot-form"

const CtaNewsLetter = ({ position }) => {
  position = position || 0
  const [user, setUser] = useState({})

  const fieldsInitialValues = {
    optin: false,
    email: "",
  }

  const [initialValues, setInitialValues] = useState(fieldsInitialValues)

  useEffect(() => {
    if (!firebase) return
    firebase.auth().onAuthStateChanged(async (user) => {
      if (!user) return await firebase.auth().signInAnonymously()
      const userData = await getUser(user.uid)
      if (userData) setInitialValues(userData)
      setUser(user)
    })
  }, [])

  return (
    <SideColumnWrapper>
      <div className={NewsLetter}>
        <div className={NewsLetterInner && "form-newsletter"}>
          <p className={sideColumnTitle}>
            Elke week tips en inspiratie in je inbox!
          </p>

          <p className={sideColumnText}>
            Schrijf je in voor onze nieuwsbrief en ontvang elke week een mail
            met praktische informatie die je bedrijf écht vooruit helpt.
          </p>

          <HubSpotForm
            formId="1f0705a4-9d0f-4a81-a130-a31651b9b0a4"
            idModifier={`side-column-${position}`}
          />

        </div>
      </div>
    </SideColumnWrapper>
  )
}

export default CtaNewsLetter
